// removed by extract-text-webpack-plugin
module.exports = {"promo-code-form":"_1sMMxO88z _2l0xl0HVf _2ZT2UjjKl MtY8M0FOL _38fsqHPnh _1lCmGBorg _1vgzIe30_ _1B4qcaoCi","actions":"_11szJibt8 _17qxy1jyE Q5jr4ygU0 _1K-PUKdV4","button":"_3BryzAYpB _3fIeCGwgt"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/promo-code-form/promo-code-form.css
 ** module id = 2150
 ** module chunks = 0
 **/